<div class="container" *ngIf="chartOptions">
  <div echarts [options]="chartOptions"></div>
</div>

<!-- html -->

<div class="mb-4 flex d-flex justify-content-end align-items-center d-flex">
  <button class="btn-custom border-0 px-5 py-2 mr-4" style="min-width: 180px;" (click)="downloadSurveyTeamDataCSV()">
    <fa-icon class="mr-2" [icon]="faDownload"></fa-icon>
    <span>{{ "generic.export-team-data" | translate }}</span>
  </button>

  <button class="btn-custom border-0 px-5 py-2"
          [ngClass]="{
            'mr-4': selectedEmailIds.size > 0,
            'bg-danger': singleTeamMemberToAddActive
          }"
          style="min-width: 180px;"
          (click)="toggleAddNewTeamMemberMode()">
    <fa-icon class="mr-2" *ngIf="!singleTeamMemberToAddActive" [icon]="faPlusCircle"></fa-icon>
    <fa-icon class="mr-2" *ngIf="singleTeamMemberToAddActive" [icon]="faTimes"></fa-icon>
    <span
      *ngIf="!singleTeamMemberToAddActive">{{ 'components.decision-table.new-decision-table.compile-proposal.add-team-member' | translate }}</span>
    <span *ngIf="singleTeamMemberToAddActive">{{ 'generic.cancel' | translate }}</span>
  </button>

  <button *ngIf="selectedEmailIds.size > 0"
          class="btn-custom border-0 px-5 py-2"
          [ngClass]="{
            'mr-4': selectedEmailIds.size > 0 && members?.length - selectedEmailIds.size > 0,
          }"
          style="min-width: 180px;"
          (click)="resendSelectedInvitations()">
    <fa-icon class="mr-2" [icon]="faBullhorn"></fa-icon>
    <span>{{ "generic.send-reminder" | translate }}</span>
  </button>
  <button *ngIf="selectedEmailIds.size > 0 && members?.length - selectedEmailIds.size > 0"
          class="btn-custom border-0 px-5 py-2 bg-danger"
          style="min-width: 180px;"
          (click)="deleteSelectedMembers()">
    <fa-icon class="mr-2" [icon]="faTrash"></fa-icon>
    <span>{{ "generic.remove" | translate }}</span>
  </button>
</div>

<mat-form-field appearance="outline" class="mr-4">
  <mat-label>{{ "components.surveys.survey-team.survey-team.filter-by-answer" | translate }}</mat-label>
  <mat-select name="responseFilter" [(ngModel)]="filters.responseStatus" (selectionChange)="applyFilter()">
    <mat-option value="ALL">{{ "components.decision-table.new-decision-table.select-framework.all" | translate }}
    </mat-option>
    <mat-option value="SENT">{{ "components.surveys.survey-team.survey-team.filter-by-answered" | translate }}
    </mat-option>
    <mat-option value="DRAFT">{{ "generic.answers.draft" | translate }}</mat-option>
    <mat-option value="NOT_SENT">{{ "components.surveys.survey-team.survey-team.filter-by-not-answered" | translate }}
    </mat-option>
  </mat-select>
</mat-form-field>

<mat-form-field appearance="outline" *ngIf="emailStatuses?.length > 0">
  <mat-label>{{ "components.surveys.survey-team.survey-team.filter-by-email-status" | translate }}</mat-label>
  <mat-select name="emailStatusFilter"
              [(ngModel)]="filters.emailStatus"
              (selectionChange)="applyFilter()"
              multiple>
    <mat-option *ngFor="let status of emailStatuses" [value]="status">
      {{ "generic.email-status." + status + ".title" | translate }}
    </mat-option>
  </mat-select>
</mat-form-field>

<mat-form-field appearance="standard" class="w-100 my-1">
  <mat-label>{{ 'generic.searchByNameOrEmail' | translate }}</mat-label>
  <input matInput (keyup)="applyFilter()" placeholder="{{ 'generic.searchByTextPlaceholder' | translate }}" [(ngModel)]="filters.searchValue">
</mat-form-field>


<div class="box box-two-row mb-5" *ngIf="singleTeamMemberToAddActive">
  <app-single-team-member
    [removable]="false"
    [context]="'survey-team'"
    [addButton]="true"
    (addedTeamMember)="onAddTeamMember($event)"
    [surveyId]="surveyId"
  />
</div>

<ng-container *ngIf="dataSource">
  <mat-table [dataSource]="dataSource" class="table-primary">

    <ng-container matColumnDef="name">
      <mat-header-cell *matHeaderCellDef> {{ 'generic.name' | translate }}</mat-header-cell>
      <div class="row flex-column">
        <mat-cell *matCellDef="let row"> {{ row.name }}</mat-cell>
      </div>
    </ng-container>

    <ng-container matColumnDef="email">
      <mat-header-cell *matHeaderCellDef> {{ 'generic.email' | translate }}</mat-header-cell>
      <div class="row flex-column">
        <mat-cell *matCellDef="let row"> {{ row.email }}</mat-cell>
      </div>
    </ng-container>

    <ng-container matColumnDef="response_status">
      <mat-header-cell
        *matHeaderCellDef> {{ 'components.decision-table.decision-table-dashboard.answers-to-form' | translate }}
      </mat-header-cell>
      <div class="row flex-column">
        <mat-cell *matCellDef="let row">
          <ng-container [ngSwitch]="row.response_status">
            <mat-chip *ngSwitchCase="'SENT'"
                      selectable="false"
                      style="justify-content:center; background-color: #4caf50;"
                      class="text-white p-1 px-2 rounded">
              {{ 'generic.answers.yes' | translate }}
            </mat-chip>
            <mat-chip *ngSwitchCase="'DRAFT'"
                      selectable="false"
                      style="justify-content:center; background-color: #bca900;"
                      class="text-white p-1 px-2 rounded">
              {{ 'generic.answers.draft' | translate }}
            </mat-chip>
            <mat-chip *ngSwitchDefault
                      selectable="false"
                      style="justify-content:center; background-color: #f44336;"
                      class="text-white p-1 px-2 rounded">
              {{ 'generic.answers.no' | translate }}
            </mat-chip>
          </ng-container>
        </mat-cell>
      </div>
    </ng-container>

    <!-- html -->
    <ng-container matColumnDef="email_status">
      <mat-header-cell *matHeaderCellDef>
        {{ 'components.decision-table.decision-table-dashboard.email-status' | translate }}
        <mat-checkbox
          [checked]="isAllSelected()"
          [indeterminate]="isSomeSelected()"
          (change)="toggleSelectAll($event)"
          class="ml-2"
        >
        </mat-checkbox>
      </mat-header-cell>

      <div class="row flex-column">
        <mat-cell *matCellDef="let row">
          <mat-chip-list>
            <!-- envelope chip: mantiene la funzionalità di mostrare le risposte -->
            <mat-chip (click)="emailResponsesAvailable(row) ? showEmailResponses(row) : ''; $event.stopPropagation()"
                      role="button"
                      selectable="true"
                      [matTooltip]="
    ('generic.email-status.' + (row.last_status_invitation_email | replaceSpaces) + '.title') | translate
  "
                      [matTooltipPosition]="'below'"
                      [ngStyle]="{
                    'background-color': emailColorByTeamMember(row),
                    'border': isEmailSelected(row) ? '2px solid rgba(0,0,0,0.2)' : 'none'
                  }"
                      class="text-white cursor">
              <fa-icon [icon]="faEnvelope"></fa-icon>
            </mat-chip>

            <button (click)="copyLink(row.invitation_link); $event.stopPropagation()" color="primary" mat-icon-button
                    *ngIf="row.invitation_link"
                    matTooltip="{{'generic.buttons.copy-link' | translate}}"
                    [matTooltipPosition]="'below'">
              <fa-icon [icon]="faLink"></fa-icon>
            </button>

            <ng-container *ngIf="selectedEmailIds?.size < 1">
              <!--            <button (click)="resendInvitation([row.id]); $event.stopPropagation()" color="primary" mat-icon-button-->
              <!--                    matTooltip="{{'generic.buttons.modify' | translate}}"-->
              <!--                    [matTooltipPosition]="'below'">-->
              <!--              <fa-icon [icon]="faEdit"></fa-icon>-->
              <!--            </button>-->

              <button (click)="resendInvitation([row.id]); $event.stopPropagation()" color="primary" mat-icon-button
                      matTooltip="{{'components.decision-table.decision-table-dashboard.tooltip.resend-email' | translate}}"
                      [matTooltipPosition]="'below'">
                <fa-icon [icon]="faBullhorn"></fa-icon>
              </button>

              <button (click)="deleteTeamMembers([row.id]); $event.stopPropagation()" color="primary" mat-icon-button
                      *ngIf="members?.length > 1"
                      matTooltip="{{'generic.remove' | translate}}"
                      [matTooltipPosition]="'below'">
                <fa-icon [icon]="faTrash"></fa-icon>
              </button>
            </ng-container>
          </mat-chip-list>

          <!-- checkbox per selezione collettiva -->
          <mat-checkbox class="ml-3"
                        [checked]="isEmailSelected(row)"
                        (change)="toggleSelectEmail(row, $event)"
                        (click)="$event.stopPropagation()"
                        [aria-label]="'select-'+row.email">
          </mat-checkbox>
        </mat-cell>
      </div>
    </ng-container>


    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>

  </mat-table>
  <mat-paginator #paginator [pageSizeOptions]="[5, 10, 25, 100]" aria-label="Select page of users"></mat-paginator>

</ng-container>
